import * as ConfirmModalActions from '../actions/confirm-modal.actions';
import * as ConfirmModalState from '../states/confirm-modal.state';

export class State extends ConfirmModalState.State { }

const initialState: ConfirmModalState.State = ConfirmModalState.initialState;

/**
 *
 *
 * @export
 * @param {*} [state=initialState]
 * @param {ConfirmModalActions.Actions} action
 * @returns {ConfirmModalState.State}
 */
export function reducer(state = initialState, action: ConfirmModalActions.Actions): ConfirmModalState.State {

	switch (action.type) {
		case ConfirmModalActions.ActionTypes.PUT_TITLE:
			state = Object.assign({}, state, { title: action.payload });
			return state;
		case ConfirmModalActions.ActionTypes.PUT_BODY_MSG:
			state = Object.assign({}, state, { body: action.payload });
			return state;
		case ConfirmModalActions.ActionTypes.PUT_OK_LABEL:
			state = Object.assign({}, state, { okLabel: action.payload });
			return state;
		case ConfirmModalActions.ActionTypes.PUT_CANCEL_LABEL:
			state = Object.assign({}, state, { cancelLabel: action.payload });
			return state;
		case ConfirmModalActions.ActionTypes.PUT_CONFIRM:
			state = Object.assign({}, state, { confirm: action.payload });
			return state;
		case ConfirmModalActions.ActionTypes.PUT_IS_ACCENT:
			state = Object.assign({}, state, { isAccent: action.payload });
			return state;
		case ConfirmModalActions.ActionTypes.RESET:
			state = Object.assign({}, state, initialState);
			return state;
		default:
			return state;
	}
}

export const getTitle = (state: ConfirmModalState.State) => state.title;
export const getBodyMsg = (state: ConfirmModalState.State) => state.body;
export const getOkLabel = (state: ConfirmModalState.State) => state.okLabel;
export const getCancelLabel = (state: ConfirmModalState.State) => state.cancelLabel;
export const getConfirm = (state: ConfirmModalState.State) => state.confirm;
export const getIsAccent = (state: ConfirmModalState.State) => state.isAccent;
